import { Modal } from 'antd';
import { FillButton } from 'components/elements';
import { useState } from 'react';
import DaumPostCode from 'react-daum-postcode';

const AddressModal = ({ fnUpdateAddr }) => {
  const [open, setOpen] = useState(false)

  const fnComplete = (data) => {
    const { zonecode, address, bcode, sido, sigungu} = data
    fnUpdateAddr({
      zipCode: zonecode,
      addr: address,
      sigunguCd: bcode,
      sido:sido, 
      sigungu:sigungu,
    })
    fnClose()
  }

  const fnClose = () => {
    setOpen(false)
  }

  return (<>
    <FillButton label={'우편번호 찾기'} backgroundColor={'var(--color-gray03)'} onClick={() => setOpen(true)} />

    <Modal
      key={open ? 'open' : 'closed'}
      width={550}
      open={open}
      onCancel={fnClose}
      footer={[
        <FillButton label='닫기' onClick={fnClose} />
      ]}
      styles={{
        body: {
          padding: '3rem 1rem 1rem 1rem'
        }
      }}
    >
      <DaumPostCode
        onComplete={fnComplete}
        // onAutoClose={fnClose}
        style={{ height: 600 }}
        // autoClose
      />
    </Modal>
  </>)
}

export default AddressModal;